// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"272":"pdfmake","712":"canvg","868":"xlsx"}[chunkId] + "." + {"272":"da64500d","712":"41c00423","868":"960094ba"}[chunkId] + ".chunk.js";
};